// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CreatorListItem {
  position: relative;
  border-radius: 4px;
  margin: 0 0 4px;
  transition-duration: 0.2s;
}
.CreatorListItem .card-component-container {
  padding: 0;
}
.CreatorListItem .follow-wrapper {
  margin-left: auto;
}
.CreatorListItem .brand-flag {
  font-size: 12px;
  border: 1px dashed var(--base_color1);
  color: var(--base_color1);
  padding: 3px 3px;
  box-sizing: border-box;
  border-radius: 999em;
  font-weight: 600;
  text-align: center;
}
.CreatorListItem .brand-flag.isBrand {
  border-color: transparent;
  background-color: var(--color_primary_500);
  color: var(--base_color2);
}
.CreatorListItem .select-tag {
  border: 1px solid var(--gray);
  color: var(--gray);
  font-size: 12px;
  padding: 3px 9px;
  border-radius: 999em;
  font-weight: 600;
  margin: 0 16px 0 25px;
  visibility: hidden;
}
.CreatorListItem .CreatorListItemContent.with-tiktok, .CreatorListItem .CreatorListItemContent.with-twitch {
  grid-template-columns: 24px 66px 230px repeat(7, 1fr) 180px;
}
.CreatorListItem .CreatorListItemContent.default {
  grid-template-columns: 24px 66px 230px repeat(5, 1fr) 180px;
}
.CreatorListItem .CreatorListItemContent.with-twitch-tiktok {
  grid-template-columns: 24px 66px 230px repeat(9, 1fr) 165px;
  justify-items: center;
}
.CreatorListItem .CreatorListItemContent.custom-list-item {
  grid-template-columns: 12px 24px 66px 230px repeat(5, 1fr);
}
.CreatorListItem .CreatorListItemContent {
  display: grid;
  grid-column-gap: 8px;
  align-items: center;
  justify-items: left;
  height: 96px;
  cursor: pointer;
  padding: 0 8px;
  color: var(--primary_dark2);
  font-size: 14px;
}
.CreatorListItem .CreatorListItemContent .pinCreatorList {
  justify-self: center;
}
.CreatorListItem .CreatorListItemContent .itemColorCreatorList {
  width: 12px;
  height: 12px;
  border-radius: 12px;
}
.CreatorListItem .CreatorListItemContent .ribbon-pin .icon-pin {
  fill: var(--base_color2);
}
.CreatorListItem .CreatorListItemContent .ribbon-pin .icon-pin-remove {
  display: none;
}
.CreatorListItem .CreatorListItemContent .ribbon-pin.selected-pin {
  height: 24px;
  width: 24px;
  border-radius: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-color: transparent;
  background: var(--color_primary_500);
}
.CreatorListItem .CreatorListItemContent .ribbon-pin.selected-pin .icon-pin path:first-child {
  fill: var(--color_primary_500);
}
.CreatorListItem .CreatorListItemContent .ribbon-pin.selected-pin:hover {
  background: var(--color_primary_500);
  border: 1px solid var(--color_primary_500);
}
.CreatorListItem .CreatorListItemContent .ribbon-pin.selected-pin:hover .icon-pin-remove {
  display: block;
  fill: var(--base_color2);
}
.CreatorListItem .CreatorListItemContent .ribbon-pin.selected-pin:hover .icon-pin {
  display: none;
}
.CreatorListItem .CreatorListItemContent .thumbnail {
  height: 66px;
  width: 66px;
}
.CreatorListItem .CreatorListItemContent .thumbnail div {
  width: 24px;
  height: 24px;
}
.CreatorListItem .CreatorListItemContent .thumbnail .provider [class^=dist_providerIcon] {
  padding: 4px 3px;
  border: 0.5px solid var(--base_color2);
}
.CreatorListItem .CreatorListItemContent .thumbnail > img:first-of-type,
.CreatorListItem .CreatorListItemContent .thumbnail > svg:first-of-type {
  border: 1px solid var(--gray_light2);
  border-radius: 100%;
  overflow: hidden;
}
.CreatorListItem .CreatorListItemContent .title-container {
  width: 100%;
  padding-left: 12px;
}
.CreatorListItem .CreatorListItemContent .title-container .title {
  font-weight: normal;
  color: var(--base_color1);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 370px;
  line-height: 20px;
}
.CreatorListItem .CreatorListItemContent .title-container .brand,
.CreatorListItem .CreatorListItemContent .title-container .country {
  font-size: 12px;
  line-height: 15px;
}
.CreatorListItem .CreatorListItemContent .title-container .brand {
  color: var(--color_primary_500);
}
.CreatorListItem .CreatorListItemContent .title-container .CreatorListItem-brand-group {
  max-width: -webkit-max-content;
  max-width: -moz-max-content;
  max-width: max-content;
}
.CreatorListItem .CreatorListItemContent .title-container .country {
  color: var(--gray_dark1);
}
.CreatorListItem .CreatorListItemContent .title-container .brand-country {
  display: flex;
}
.CreatorListItem .CreatorListItemContent .title-container .brand-country span:last-child {
  margin-left: 3px;
}
.CreatorListItem .CreatorListItemContent .title-container .TopicListSmall {
  padding-top: 8px;
  flex: 1 1;
}
.CreatorListItem .CreatorListItemContent .title-container .TopicListSmall h6 {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 330px;
}
.CreatorListItem .CreatorListItemContent .CreatorListItem-subscribers,
.CreatorListItem .CreatorListItemContent .total-engagement,
.CreatorListItem .CreatorListItemContent .CreatorListItem-total-views,
.CreatorListItem .CreatorListItemContent .CreatorListItem-total,
.CreatorListItem .CreatorListItemContent .engagement-ratio,
.CreatorListItem .CreatorListItemContent .videos,
.CreatorListItem .CreatorListItemContent .average-engagement,
.CreatorListItem .CreatorListItemContent .average-views {
  white-space: nowrap;
  display: flex;
  align-items: center;
}
.CreatorListItem .CreatorListItemContent .CreatorListItem-subscribers .tooltip-variation,
.CreatorListItem .CreatorListItemContent .total-engagement .tooltip-variation,
.CreatorListItem .CreatorListItemContent .CreatorListItem-total-views .tooltip-variation,
.CreatorListItem .CreatorListItemContent .CreatorListItem-total .tooltip-variation,
.CreatorListItem .CreatorListItemContent .engagement-ratio .tooltip-variation,
.CreatorListItem .CreatorListItemContent .videos .tooltip-variation,
.CreatorListItem .CreatorListItemContent .average-engagement .tooltip-variation,
.CreatorListItem .CreatorListItemContent .average-views .tooltip-variation {
  display: inline-flex;
}
.CreatorListItem .CreatorListItemContent .CreatorListItem-total,
.CreatorListItem .CreatorListItemContent .CreatorListItem-subscribers {
  flex-direction: column;
  align-items: flex-start;
}
.CreatorListItem .CreatorListItemContent .CreatorListItem-total-views {
  flex-direction: column;
}
.CreatorListItem .CreatorListItemContent .CreatorListItem-text {
  align-self: flex-start;
  font-size: 12px;
  line-height: 15px;
  color: var(--gray);
}
.CreatorListItem .CreatorListItemContent .creator-list-item-checkbox {
  box-shadow: none;
}
.CreatorListItem .CreatorListItem-actions {
  display: flex;
  align-items: center;
  width: 100%;
}
.CreatorListItem.selected {
  background-color: var(--background);
}
.CreatorListItem.selected .select-tag {
  visibility: visible;
}
.CreatorListItem:hover {
  background-color: var(--background);
}
.CreatorListItem:hover .select-tag-container {
  opacity: 1;
}
.CreatorListItem:hover .ribbon-pin {
  height: 24px;
  width: 24px;
  border-radius: 24px;
  border: 1px solid var(--gray);
  display: flex;
  justify-content: center;
  align-items: center;
}
.CreatorListItem:hover .ribbon-pin .icon-pin {
  fill: var(--base_color2);
}
.CreatorListItem:hover .ribbon-pin .icon-pin-remove {
  display: none;
}
.CreatorListItem:hover .ribbon-pin .icon-pin {
  fill: var(--gray);
}
.CreatorListItem:hover .select-tag {
  visibility: visible;
}`, "",{"version":3,"sources":["webpack://./src/components/CreatorListItem/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AACF;AACE;EACE,UAAA;AACJ;AAEE;EACE,iBAAA;AAAJ;AAGE;EACE,eAAA;EACA,qCAAA;EACA,yBAAA;EACA,gBAAA;EACA,sBAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;AADJ;AAGI;EACE,yBAAA;EACA,0CAAA;EACA,yBAAA;AADN;AAKE;EACE,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;AAHJ;AAOI;EAEE,2DAAA;AANN;AASI;EACE,2DAAA;AAPN;AAUI;EACE,2DAAA;EACA,qBAAA;AARN;AAWI;EACE,0DAAA;AATN;AAPE;EAmBE,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,2BAAA;EACA,eAAA;AATJ;AAWI;EACE,oBAAA;AATN;AAYI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAVN;AAcM;EACE,wBAAA;AAZR;AAeM;EACE,aAAA;AAbR;AAgBM;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,oCAAA;AAdR;AAiBU;EACE,8BAAA;AAfZ;AAmBQ;EACE,oCAAA;EACA,0CAAA;AAjBV;AAmBU;EACE,cAAA;EACA,wBAAA;AAjBZ;AAoBU;EACE,aAAA;AAlBZ;AAwBI;EACE,YAAA;EACA,WAAA;AAtBN;AAwBM;EACE,WAAA;EACA,YAAA;AAtBR;AAyBM;EACE,gBAAA;EACA,sCAAA;AAvBR;AA2BI;;EAEE,oCAAA;EACA,mBAAA;EACA,gBAAA;AAzBN;AA4BI;EACE,WAAA;EACA,kBAAA;AA1BN;AA4BM;EACE,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;AA1BR;AA6BM;;EAEE,eAAA;EACA,iBAAA;AA3BR;AA8BM;EACE,+BAAA;AA5BR;AA+BM;EACE,8BAAA;EAAA,2BAAA;EAAA,sBAAA;AA7BR;AAgCM;EACE,wBAAA;AA9BR;AAiCM;EACE,aAAA;AA/BR;AAiCQ;EACE,gBAAA;AA/BV;AAmCM;EACE,gBAAA;EACA,SAAA;AAjCR;AAmCQ;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAjCV;AAsCI;;;;;;;;EAQE,mBAAA;EACA,aAAA;EACA,mBAAA;AApCN;AAsCM;;;;;;;;EACE,oBAAA;AA7BR;AAiCI;;EAEE,sBAAA;EACA,uBAAA;AA/BN;AAkCI;EACE,sBAAA;AAhCN;AAmCI;EACE,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAjCN;AAoCI;EACE,gBAAA;AAlCN;AAsCE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AApCJ;AAuCE;EACE,mCAAA;AArCJ;AAuCI;EACE,mBAAA;AArCN;AAyCE;EACE,mCAAA;AAvCJ;AAyCI;EACE,UAAA;AAvCN;AA0CI;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,6BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAxCN;AA0CM;EACE,wBAAA;AAxCR;AA2CM;EACE,aAAA;AAzCR;AA4CM;EACE,iBAAA;AA1CR;AA8CI;EACE,mBAAA;AA5CN","sourcesContent":[".CreatorListItem {\n  position: relative;\n  border-radius: 4px;\n  margin: 0 0 4px;\n  transition-duration: 0.2s;\n\n  .card-component-container {\n    padding: 0;\n  }\n\n  .follow-wrapper {\n    margin-left: auto;\n  }\n\n  .brand-flag {\n    font-size: 12px;\n    border: 1px dashed var(--base_color1);\n    color: var(--base_color1);\n    padding: 3px 3px;\n    box-sizing: border-box;\n    border-radius: 999em;\n    font-weight: 600;\n    text-align: center;\n\n    &.isBrand {\n      border-color: transparent;\n      background-color: var(--color_primary_500);\n      color: var(--base_color2);\n    }\n  }\n\n  .select-tag {\n    border: 1px solid var(--gray);\n    color: var(--gray);\n    font-size: 12px;\n    padding: 3px 9px;\n    border-radius: 999em;\n    font-weight: 600;\n    margin: 0 16px 0 25px;\n    visibility: hidden;\n  }\n\n  .CreatorListItemContent {\n    &.with-tiktok,\n    &.with-twitch {\n      grid-template-columns: 24px 66px 230px repeat(7, 1fr) 180px;\n    }\n\n    &.default {\n      grid-template-columns: 24px 66px 230px repeat(5, 1fr) 180px;\n    }\n\n    &.with-twitch-tiktok {\n      grid-template-columns: 24px 66px 230px repeat(9, 1fr) 165px;\n      justify-items: center;\n    }\n\n    &.custom-list-item {\n      grid-template-columns: 12px 24px 66px 230px repeat(5, 1fr);\n    }\n\n    display: grid;\n    grid-column-gap: 8px;\n    align-items: center;\n    justify-items: left;\n    height: 96px;\n    cursor: pointer;\n    padding: 0 8px;\n    color: var(--primary_dark2);\n    font-size: 14px;\n\n    .pinCreatorList {\n      justify-self: center;\n    }\n\n    .itemColorCreatorList {\n      width: 12px;\n      height: 12px;\n      border-radius: 12px;\n    }\n\n    .ribbon-pin {\n      .icon-pin {\n        fill: var(--base_color2);\n      }\n\n      .icon-pin-remove {\n        display: none;\n      }\n\n      &.selected-pin {\n        height: 24px;\n        width: 24px;\n        border-radius: 24px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        border-color: transparent;\n        background: var(--color_primary_500);\n\n        .icon-pin {\n          path:first-child {\n            fill: var(--color_primary_500);\n          }\n        }\n\n        &:hover {\n          background: var(--color_primary_500);\n          border: 1px solid var(--color_primary_500);\n\n          .icon-pin-remove {\n            display: block;\n            fill: var(--base_color2);\n          }\n\n          .icon-pin {\n            display: none;\n          }\n        }\n      }\n    }\n\n    .thumbnail {\n      height: 66px;\n      width: 66px;\n\n      div {\n        width: 24px;\n        height: 24px;\n      }\n\n      .provider [class^='dist_providerIcon'] {\n        padding: 4px 3px;\n        border: 0.5px solid var(--base_color2);\n      }\n    }\n\n    .thumbnail > img:first-of-type,\n    .thumbnail > svg:first-of-type {\n      border: 1px solid var(--gray_light2);\n      border-radius: 100%;\n      overflow: hidden;\n    }\n\n    .title-container {\n      width: 100%;\n      padding-left: 12px;\n\n      .title {\n        font-weight: normal;\n        color: var(--base_color1);\n        text-overflow: ellipsis;\n        overflow: hidden;\n        white-space: nowrap;\n        max-width: 370px;\n        line-height: 20px;\n      }\n\n      .brand,\n      .country {\n        font-size: 12px;\n        line-height: 15px;\n      }\n\n      .brand {\n        color: var(--color_primary_500);\n      }\n\n      .CreatorListItem-brand-group {\n        max-width: max-content;\n      }\n\n      .country {\n        color: var(--gray_dark1);\n      }\n\n      .brand-country {\n        display: flex;\n\n        span:last-child {\n          margin-left: 3px;\n        }\n      }\n\n      .TopicListSmall {\n        padding-top: 8px;\n        flex: 1;\n\n        h6 {\n          text-overflow: ellipsis;\n          overflow: hidden;\n          white-space: nowrap;\n          max-width: 330px;\n        }\n      }\n    }\n\n    .CreatorListItem-subscribers,\n    .total-engagement,\n    .CreatorListItem-total-views,\n    .CreatorListItem-total,\n    .engagement-ratio,\n    .videos,\n    .average-engagement,\n    .average-views {\n      white-space: nowrap;\n      display: flex;\n      align-items: center;\n\n      .tooltip-variation {\n        display: inline-flex;\n      }\n    }\n\n    .CreatorListItem-total,\n    .CreatorListItem-subscribers {\n      flex-direction: column;\n      align-items: flex-start;\n    }\n\n    .CreatorListItem-total-views {\n      flex-direction: column;\n    }\n\n    .CreatorListItem-text {\n      align-self: flex-start;\n      font-size: 12px;\n      line-height: 15px;\n      color: var(--gray);\n    }\n\n    .creator-list-item-checkbox {\n      box-shadow: none;\n    }\n  }\n\n  .CreatorListItem-actions {\n    display: flex;\n    align-items: center;\n    width: 100%;\n  }\n\n  &.selected {\n    background-color: var(--background);\n\n    .select-tag {\n      visibility: visible;\n    }\n  }\n\n  &:hover {\n    background-color: var(--background);\n\n    .select-tag-container {\n      opacity: 1;\n    }\n\n    .ribbon-pin {\n      height: 24px;\n      width: 24px;\n      border-radius: 24px;\n      border: 1px solid var(--gray);\n      display: flex;\n      justify-content: center;\n      align-items: center;\n\n      .icon-pin {\n        fill: var(--base_color2);\n      }\n\n      .icon-pin-remove {\n        display: none;\n      }\n\n      .icon-pin {\n        fill: var(--gray);\n      }\n    }\n\n    .select-tag {\n      visibility: visible;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
